import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-79cf3ed1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "comments" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "comments__title" }, "Комментарии врача", -1))
const _hoisted_3 = { class: "comments__item" }
const _hoisted_4 = { class: "comments__item-header" }
const _hoisted_5 = { class: "comments__item-text" }
const _hoisted_6 = { class: "comments__item-footer" }
const _hoisted_7 = { class: "comments__item-info" }
const _hoisted_8 = {
  key: 1,
  class: "comments__empty"
}

import { computed, PropType } from 'vue'
import { useRoute } from 'vue-router'
import { FAddComment } from '@/features/FAddComment'
import { FRemoveComment } from '@/features/FRemoveComment'
import {
  CommentTemplateType,
  CommentType,
  ReportViewType,
} from '@/shared/types'
import { getDateFormat } from '@/shared/utils'
import { DATE_FORMAT } from '@/shared/constants'
import { useOrganizationModules } from '@/shared/composables'
import { Document } from '@element-plus/icons-vue'


export default /*#__PURE__*/_defineComponent({
  props: {
  templates: Array as PropType<CommentTemplateType[]>,
  comments: Array as PropType<CommentType[]>,
  reportType: String as PropType<ReportViewType>,
  isOld: Boolean,
},
  emits: ['update'],
  setup(__props, { emit }) {

const props = __props





const route = useRoute()

const { organizationModules } = useOrganizationModules()

const reportId = computed(() => Number(route.params.reportId))

const getDate = (comment: CommentType): string => {
  return getDateFormat(new Date(comment.updated_at), DATE_FORMAT.dmyLong)
}

const handleUpdateComments = (): void => {
  emit('update')
}
const mapper = {
  plaqueIndex: 'plaque',
  periodontal: 'periodontology',
  screening: 'screening',
  brushMap: 'brushmap',
  riskMap: 'riskmap',
}

const editAvailable = computed(
  () => organizationModules.value.indexOf(mapper[props.reportType]) > -1
)

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass([{
        'comments__content--old': __props.isOld || !_unref(editAvailable),
      }, "comments__content"])
    }, [
      _hoisted_2,
      (__props.comments.length)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(__props.comments, (comment) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("p", _hoisted_5, _toDisplayString(comment.text), 1)
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("p", _hoisted_7, [
                  _createTextVNode(_toDisplayString(getDate(comment)) + " · Врач: " + _toDisplayString(comment.user_name) + " ", 1),
                  (comment.files && comment.files.length)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(Document))
                          ]),
                          _: 1
                        }),
                        _createElementVNode("span", null, _toDisplayString(`(${comment.files.length})`), 1)
                      ], 64))
                    : _createCommentVNode("", true)
                ]),
                (!__props.isOld)
                  ? _withDirectives((_openBlock(), _createBlock(_unref(FRemoveComment), {
                      key: 0,
                      "comment-id": comment.id,
                      "report-type": __props.reportType,
                      onUpdate: handleUpdateComments
                    }, null, 8, ["comment-id", "report-type"])), [
                      [_vShow, _unref(editAvailable)]
                    ])
                  : _createCommentVNode("", true)
              ])
            ]))
          }), 256))
        : (_openBlock(), _createElementBlock("p", _hoisted_8, "Пока что нет комментариев"))
    ], 2),
    (!__props.isOld)
      ? _withDirectives((_openBlock(), _createBlock(_unref(FAddComment), {
          key: 0,
          "report-id": _unref(reportId),
          "report-type": __props.reportType,
          templates: __props.templates,
          onUpdate: handleUpdateComments
        }, null, 8, ["report-id", "report-type", "templates"])), [
          [_vShow, _unref(editAvailable)]
        ])
      : _createCommentVNode("", true)
  ]))
}
}

})